import { style } from '@vanilla-extract/css'

const section = style({
  background: `
    linear-gradient(0deg, #E5F0F0, #E5F0F0),
    linear-gradient(180.01deg, rgba(242, 241, 239, 0) 40.8%, #F2F1EF 99.99%);
  `,
})

export const styles = {
  section,
}
